import('./bootstrapApp')

export default {}
